module.exports = __webpack_public_path__ + "img/logo-approval.c5272197.svg";